import React, { Dispatch, SetStateAction } from 'react';
import { defaultFeatureDecisions } from '~/react-hooks/use-features';

export interface UserContextProps extends User {
  set?: Dispatch<SetStateAction<User>>;
  stats: BonjoroStatic['userStats'];
}

export default React.createContext<UserContextProps>({
  id: '',
  features: defaultFeatureDecisions,
  campaigns: null,
} as UserContextProps);
